import Repository from "./Repository";

const resource = "/Utilisateur";

export default {
  login({ email, password }) {
    return Repository.post(`${resource}/Login`, {
      email,
      password,
      applicationId: ["AD7A41DE-9817-41A0-B4C0-22A0FFEB22B6"]
    });
  },
  resetPassword({ email, callbackUrl }) {
    return Repository.post(`${resource}/ResetPassword`, {
      email,
      callbackUrl
    });
  },
  setPassword({ password, token }) {
    return Repository.put(`${resource}/setPassword`, '"' + password + '"', {
      headers: {
        Token: token,
        "Content-type": "application/json"
      }
    });
  },
  checkToken({ token }) {
    return Repository.get(`${resource}/checkToken`, {
      headers: {
        Token: token,
        "Content-type": "application/json"
      }
    }).catch(function(error) {
      // return reponse even if an error it raised
      return error.response;
    });
  }
};
